import { useEffect } from 'react';
import useUniqueHash from './useUniqueHash';

const useSingletonOpenComponent = (singletonManager, setIsOpen) => {
  const componentUniqueId = useUniqueHash();

  useEffect(() => {
    singletonManager.addListener((id, isOpenState) => {
      if (id === componentUniqueId) {
        setIsOpen(isOpenState);
      } else if (isOpenState) {
        setIsOpen(false);
      }
    });
  }, []);
  return componentUniqueId;
};

export default useSingletonOpenComponent;
